
@if (isReady) {
  <div class="graph-level">
    <div class="graph-level-wrapper">
      <app-graph-mixed [config]="graphConfigObs" class="graph"></app-graph-mixed>
      <ul class="graph-legend">
        <li class="not_acquired"><mat-icon svgIcon="icon_progression_not_acquired"></mat-icon><span>{{ 'graph.progression_not_acquired' | translate }}</span></li>
        <li class="to_do"><mat-icon svgIcon="icon_progression_to_do"></mat-icon><span>{{ 'graph.progression_to_do' | translate }}</span></li>
        <li class="so_close"><mat-icon svgIcon="icon_progression_so_close"></mat-icon><span>{{ 'graph.progression_so_close' | translate }}</span></li>
        <li class="acquired"><mat-icon svgIcon="icon_progression_acquired"></mat-icon><span>{{ 'graph.progression_acquired' | translate }}</span></li>
      </ul>
    </div>
    @if (!!details) {
      <div [ngClass]="'details ' + details.class">
        <mat-toolbar [ngClass]="details.class">
          Groupe de niveau {{details.chartColumnLabel  | translate}}
        </mat-toolbar>
        <div class="table-container">
          <table [dataSource]="details.data" mat-table>
            <ng-container matColumnDef="learner">
              <th *cdkHeaderCellDef [ngClass]="'header-cell-learner ' + details.class" mat-header-cell> {{'graph_mathia.level_table_learner' | translate}} </th>
              <td *cdkCellDef="let row" class="cell-learner" mat-cell>
                {{row.learner}}
              </td>
            </ng-container>
            <ng-container matColumnDef="average">
              <th *cdkHeaderCellDef [ngClass]="'header-cell-average ' + details.class" mat-header-cell> {{'graph_mathia.level_table_average' | translate}} </th>
              <td *cdkCellDef="let row" class="cell-average" mat-cell>
                {{row.average}}
              </td>
            </ng-container>
            <ng-container matColumnDef="count">
              <th *cdkHeaderCellDef [ngClass]="'header-cell-count ' + details.class" mat-header-cell> {{'graph_mathia.level_table_count' | translate}} </th>
              <td *cdkCellDef="let row" class="cell-count" mat-cell>
                {{row.count}}
              </td>
            </ng-container>
            <ng-container matColumnDef="link">
              <th *cdkHeaderCellDef [ngClass]="'header-cell-link ' + details.class" mat-header-cell> {{'graph_mathia.level_table_link' | translate}} </th>
              <td *cdkCellDef="let row" class="cell-link" mat-cell>
                <button (click)="onTableClick(row.link)">
                  <mat-icon svgIcon="analytics"></mat-icon>
                </button>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="details.displayedColumns; sticky: true" mat-header-row></tr>
            <tr *matRowDef="let row; columns: details.displayedColumns;" mat-row></tr>
          </table>
        </div>
      </div>
    }
  </div>
} @else {
  @if (showLoader) {
    <div class="center spinner-container">
      <app-fake-stepper [options]="loaderOptions"></app-fake-stepper>
    </div>
  }
}
